module.exports = __webpack_public_path__ + "img/daizhenyu-min.3c54e56a.gif";